export const LockOpenIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="24 / security / unlock">
      <path
        id="icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 11V6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6V8H15V6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6V11H18C19.1046 11 20 11.8954 20 13V21C20 22.1046 19.1046 23 18 23H6C4.89543 23 4 22.1046 4 21V13C4 11.8954 4.89543 11 6 11H7ZM6 21V13H18V21H6ZM13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const LockClosedIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="24 / security / lock">
      <path
        id="icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 7V10H6C4.93165 10 4 10.7764 4 11.8333V20.1667C4 21.2236 4.93165 22 6 22H18C19.0684 22 20 21.2236 20 20.1667V11.8333C20 10.7764 19.0684 10 18 10H17V7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7ZM15 7V10H9V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM6 20V12H18V20H6ZM13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const FilterIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0002 13L10.7898 12.3863L10.7896 12.3862L10.7891 12.3855L10.7871 12.3829L10.779 12.3725L10.7474 12.3318L10.6255 12.175L10.1753 11.5958C9.79405 11.1053 9.26462 10.4243 8.67207 9.66235C7.48858 8.14055 6.05287 6.29535 5.0426 5H18.9478C17.9371 6.29579 16.5037 8.14135 15.3227 9.66316C14.7313 10.4252 14.2031 11.1062 13.8227 11.5968L13.3736 12.176L13.2521 12.3328L13.2205 12.3736L13.2125 12.3839L13.2104 12.3865L13.2099 12.3872L13.2098 12.3874L14.0002 13L13.2098 12.3874L13.0002 12.6579V13V19H11.0002V13V12.6571L10.7898 12.3864L10.0002 13Z"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);

export const ArrowIos = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="arrow_back_ios_24px">
      <path
        id="icon/navigation/arrow_back_ios_24px"
        d="M17.835 3.86998L16.055 2.09998L6.16504 12L16.065 21.9L17.835 20.13L9.70504 12L17.835 3.86998Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const PlaceIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9ZM9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C12.8932 6.5 13.7185 6.9765 14.1651 7.75C14.6116 8.5235 14.6116 9.4765 14.1651 10.25C13.7185 11.0235 12.8932 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9Z"
      fill="currentColor"
    />
  </svg>
);

export const PersonIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
      fill="currentColor"
    />
  </svg>
);

export const TimeIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.24 7.76C15.07 6.59 13.54 6 12 6V12L7.76 16.24C10.1 18.58 13.9 18.58 16.25 16.24C18.59 13.9 18.59 10.1 16.24 7.76ZM4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12Z"
      fill="currentColor"
    />
  </svg>
);

export const EyeHidden = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="visibility_off_24px">
      <path
        id="icon/action/visibility_off_24px"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.69 6.525L2.01 3.845L3.42 2.425L21.15 20.165L19.74 21.575L16.32 18.155C14.98 18.685 13.52 18.975 12 18.975C7 18.975 2.73 15.865 1 11.475C1.77 9.505 3.06 7.805 4.69 6.525ZM12 5.975C15.79 5.975 19.17 8.105 20.82 11.475C20.23 12.695 19.4 13.745 18.41 14.595L19.82 16.005C21.21 14.775 22.31 13.235 23 11.475C21.27 7.085 17 3.975 12 3.975C10.73 3.975 9.51 4.175 8.36 4.545L10.01 6.195C10.66 6.065 11.32 5.975 12 5.975ZM10.93 7.115L13 9.185C13.57 9.435 14.03 9.895 14.28 10.465L16.35 12.535C16.43 12.195 16.49 11.835 16.49 11.465C16.5 8.985 14.48 6.975 12 6.975C11.63 6.975 11.28 7.025 10.93 7.115ZM9.51 11.345L12.12 13.955C12.08 13.965 12.04 13.975 12 13.975C10.62 13.975 9.5 12.855 9.5 11.475C9.5 11.45 9.5025 11.43 9.505 11.41L9.505 11.41L9.505 11.41C9.5075 11.39 9.51 11.37 9.51 11.345ZM7.86 9.695L6.11 7.945C4.9 8.865 3.88 10.045 3.18 11.475C4.83 14.845 8.21 16.975 12 16.975C12.95 16.975 13.87 16.835 14.75 16.595L13.77 15.615C13.23 15.845 12.63 15.975 12 15.975C9.52 15.975 7.5 13.955 7.5 11.475C7.5 10.845 7.63 10.245 7.86 9.695Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const EyeVisible = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="visibility_24px">
      <path
        id="icon/action/visibility_24px"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C2.73 7.61 7 4.5 12 4.5C17 4.5 21.27 7.61 23 12C21.27 16.39 17 19.5 12 19.5C7 19.5 2.73 16.39 1 12ZM20.82 12C19.17 8.63 15.79 6.5 12 6.5C8.21 6.5 4.83 8.63 3.18 12C4.83 15.37 8.21 17.5 12 17.5C15.79 17.5 19.17 15.37 20.82 12ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5ZM7.5 12C7.5 9.52 9.52 7.5 12 7.5C14.48 7.5 16.5 9.52 16.5 12C16.5 14.48 14.48 16.5 12 16.5C9.52 16.5 7.5 14.48 7.5 12Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
